import styled from "styled-components";

interface Props {
  title?: string;
  desc?: string;
}

const InvalidLinkScreen = ({
  title = "유효하지 않은 링크입니다",
  desc = "링크의 유효 기간이 만료되었거나 존재하지 않는 링크입니다.",
}: Props) => {
  return (
    <Container>
      <Box>
        <Icon>🚫</Icon>
        <Title>{title}</Title>
        <Desc>{desc}</Desc>
      </Box>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #0a1929;
`;

const Box = styled.div`
  text-align: center;
  padding: 48px 64px;
  background-color: #051e34;
  border: 1px solid #1e3a52;
  border-radius: 12px;
`;

const Icon = styled.div`
  font-size: 3rem;
  margin-bottom: 16px;
`;

const Title = styled.h2`
  color: #fff;
  font-size: 1.5rem;
  margin: 0 0 12px;
`;

const Desc = styled.p`
  color: #8899aa;
  font-size: 0.95rem;
  margin: 0;
`;

export default InvalidLinkScreen;
